import React from 'react'
import ReferencesContainer from '../containers/ReferencesContainer.jsx'
import PartnersContainer from '../containers/PartnersContainer.jsx'
import ReferencesFooterContainer from '../containers/ReferencesFooterContainer.jsx'
import ProjectsArchive from '../containers/ProjectsArchive.jsx'
import ScrollToTop from '../utils/ScrollToTop.jsx'

const References = () => (
    <div>
        <ScrollToTop />
        <ReferencesContainer />
        <PartnersContainer />
        <ProjectsArchive />
        <ReferencesFooterContainer />
    </div>
)

export default References



// WEBPACK FOOTER //
// ./src/scripts/routes/References.jsx